import React from 'react';
import { FlameIcon, GiftIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { PRODUCT_PRICE, formatPrice } from '../data/config';
import { offerBonuses, offerPerks, offerVolumes } from '../data/content';
import { CheckItem } from './CheckItem';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type OfferSectionProps = {
  showReferencePrices: boolean;
  guaranteeEnabled: boolean;
};
export function OfferSection({
  guaranteeEnabled
}: OfferSectionProps) {
  return <section id="offer" className="scroll-mt-2 bg-white px-4 py-7 text-center md:px-12" data-id="element-105" data-mp="mds5fj53fiao">
      <p className="flex items-center justify-center gap-1.5 text-xs font-bold uppercase tracking-[0.25em] text-amber-700" data-id="element-106" data-mp="rey37vdm1vr2">
        <FlameIcon className="h-4 w-4 shrink-0 fill-orange-400 text-orange-600" strokeWidth={2} aria-hidden data-id="element-107" data-mp="wchimym1oekl" />
        Oferta especial de lanzamiento
      </p>

      <div className="mx-auto mt-2 max-w-lg rounded-lg border-2 border-amber-400 bg-slate-50 px-3 pb-4 pt-3.5 md:px-4" data-id="element-108" data-mp="2y3ukfespu6cf">
        <h2 className="text-2xl font-extrabold uppercase leading-tight tracking-tight text-blue-950 md:text-3xl" data-id="element-109" data-mp="12ojwue6li6mt">
          <ZapIcon className="mr-1 inline h-6 w-6 -translate-y-0.5 fill-amber-400 text-amber-500" aria-hidden data-id="element-110" data-mp="xv8rkhhflxx0" />
          Combo Completo Electricistas
        </h2>
        <p className="mx-auto mt-1 max-w-md text-xs font-bold uppercase leading-snug text-sky-600 md:text-sm" data-id="element-111" data-mp="own88k44yev6">
          El sistema de diagnóstico y soluciones eléctricas para profesionales.
        </p>

        <div className="mx-auto mt-3 max-w-[240px]" data-id="element-112" data-mp="1gn1i8591371k">
          <ProductImage linkToOffer={false} data-id="element-113" data-mp="1gl700yp55t16" />
        </div>

        <p className="mt-3 text-left text-sm font-extrabold uppercase text-blue-950" data-id="element-114" data-mp="1ckmx1ehvzv74">Llevate el sistema completo:</p>
        <ul className="mt-1.5 space-y-0.5 text-left text-sm leading-snug text-slate-600 md:text-base" data-id="element-115" data-mp="17m3b3e3amjer">
          {offerVolumes.map(item => <CheckItem key={item} data-id="element-116" data-mp="3sd3sjnlph6wz">{item}</CheckItem>)}
        </ul>

        <p className="mt-3 text-left text-sm font-extrabold uppercase text-blue-950" data-id="element-117" data-mp="3sf6v1741osil">Y además recibís:</p>
        <ul className="mt-1.5 space-y-0.5 text-left text-sm leading-snug text-slate-600 md:text-base" data-id="element-118" data-mp="3ts6gef8kn49c">
          {offerBonuses.map(item => <li key={item} className="flex items-start gap-1.5" data-id="element-119" data-mp="3ks9rqdm6m5ea">
              <GiftIcon className="mt-[3px] h-4 w-4 shrink-0 text-amber-600" strokeWidth={2.5} aria-hidden data-id="element-120" data-mp="3oumtys1pzl6b" />
              <span data-id="element-121" data-mp="3b2zyguflqgol">{item}</span>
            </li>)}
        </ul>

        <p className="mt-4 text-sm font-extrabold uppercase text-blue-950 md:text-base" data-id="element-122" data-mp="3b1ox119mpl0n">4 tomos + 4 bonos profesionales</p>
        <p className="mt-0.5 text-xs font-bold uppercase tracking-wide text-slate-500" data-id="element-123" data-mp="315u67iv94jms">Todo el sistema por un único pago</p>
        <p className="mt-1 text-5xl font-extrabold leading-none tracking-tight text-amber-500 md:text-6xl" data-id="element-124" data-mp="365gj1r763xv2">
          {formatPrice(PRODUCT_PRICE)}
        </p>
        <p className="mt-1 text-xs font-semibold text-slate-500" data-id="element-125" data-mp="2x3qquj5gouw8">Pesos argentinos • Pago único</p>

        <div className="mt-3" data-id="element-126" data-mp="2dhxdhddcbvt6">
          <CtaButton mode="checkout" subtext="Acceso digital inmediato" className="max-w-none min-h-[64px]" data-id="element-127" data-mp="2dj019cfd9i4v">
            ¡Quiero acceder al Combo Completo Electricistas!
          </CtaButton>
        </div>

        <ul className="mx-auto mt-3 grid max-w-sm grid-cols-2 gap-x-3 gap-y-1 text-left text-xs font-semibold text-slate-600 md:text-sm" data-id="element-128" data-mp="2mjodc1l798f4">
          {offerPerks.map(perk => <CheckItem key={perk} data-id="element-129" data-mp="2wg9j4p51mnk0">{perk}</CheckItem>)}
        </ul>

        {guaranteeEnabled && <p className="mx-auto mt-3 max-w-md text-xs font-bold leading-snug text-blue-950" data-id="element-130" data-mp="2rihrzxc835gv">
            <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-sky-600" aria-hidden data-id="element-131" data-mp="366vuu89n2txf" />
            Garantía de devolución de 7 días, según las condiciones de la tienda.
          </p>}
      </div>
    </section>;
}